import React from 'react';
import { CaretRight } from '@phosphor-icons/react';

export const TemplatesModal = ({ templates, createFromTemplate, creating, onClose }) => (
  <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4" onClick={onClose}>
    <div className="bg-white rounded-lg w-full max-w-2xl max-h-[80vh] overflow-y-auto p-6 border border-[#E5E7EB]" onClick={e => e.stopPropagation()} data-testid="templates-modal">
      <h2 className="font-outfit text-2xl font-bold text-[#09090B] mb-2">Case Templates</h2>
      <p className="text-sm text-[#6B7280] font-ibm mb-6">Start with a pre-built template that includes document checklists and common contradiction patterns.</p>
      <div className="space-y-3">
        {templates.map(t => (
          <div key={t._id} className="border border-[#E5E7EB] rounded-lg p-4 hover:border-[#002FA7]/30 hover:shadow-sm transition-all" data-testid={`template-${t._id}`}>
            <div className="flex items-start justify-between">
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="font-outfit font-semibold text-[#09090B]">{t.name}</h3>
                  <span className="text-xs px-1.5 py-0.5 bg-[#F3F4F6] text-[#6B7280] rounded font-ibm">{t.case_type}</span>
                </div>
                <p className="text-sm text-[#6B7280] font-ibm mb-2">{t.description}</p>
                <div className="flex items-center gap-4 text-xs text-[#6B7280] font-ibm">
                  <span>{t.checklist?.length || 0} checklist items</span>
                  <span>{t.common_patterns?.length || 0} patterns</span>
                </div>
              </div>
              <button onClick={() => createFromTemplate(t._id || t.id)} disabled={creating} data-testid={`use-template-${t._id}`}
                className="shrink-0 flex items-center gap-1 px-3 py-2 bg-[#002FA7] text-white font-ibm text-sm font-semibold rounded-md hover:bg-[#00237D] disabled:opacity-50 transition-all">
                Use <CaretRight size={14} />
              </button>
            </div>
          </div>
        ))}
      </div>
      <div className="flex justify-end mt-4">
        <button onClick={onClose} className="px-4 py-2 border border-[#E5E7EB] text-[#09090B] font-ibm text-sm rounded-md hover:bg-[#F3F4F6]">Close</button>
      </div>
    </div>
  </div>
);
